<template>
  <!-- Smart Contracts are for admin only -->
  <div v-if="
      $store.state.app.user.indexOf($store.state.auth.uid) > -1 ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.indexOf(
          $store.state.auth.uid
        ) > -1)
  ">
    <div class="flex wrap p4">
      <div class="container p4 flexy">
        <div class="flex column">
          <div class="flex between align-center">
            <!-- clear contract creator -->
            <a class="update-text sm-font m8" @click="
                inputs.newcontract
                  ? $delete(inputs, 'newcontract') && $delete(inputs, 'newcontractid')
                  : $set(
                      inputs,
                      'newcontract',
                      JSON.parse(JSON.stringify(models.contract))
                    )
              ">
              <i class="fa fa-plus" />
            </a>
            <a class="update-text xs-font" @click="$set(show, 'import', !show.import)">Import</a>
            <div v-if="show.import">
              <import type="smartcontract" :value="$store.state.app.advanced.smartcontracts"
                :obj="$store.state.app.advanced.smartcontracts" />
            </div>
            <input type="search" v-model="inputs['search contracts']" placeholder="Find contract" />
          </div>

          <div class="flex wrap">
            <div class="flex column">
              <!-- Display saved contracts -->
              <div v-for="(contract, contractkey) in contracts" :key="contractkey" class="flex xs-font">
                <div :class="show['contract' + contractkey]
                      ? 'update-border sub-container light-bg'
                      : ''
                  " class="flex column" v-if="
                    !inputs['search contracts'] ||
                    JSON.stringify(contract)
                      .toLowerCase()
                      .includes((inputs['search contracts'] || '').toLowerCase())
                  ">
                  <span class="m4 flex align-center wrap">
                    <a class="border-bottom flex align-center" @click="
                        $set(
                          show,
                          'contract' + contractkey,
                          !show['contract' + contractkey]
                        );
                  ">
                      <i class="fa fa-file-contract black-text"></i>
                      <b class="l8 r8 update-text">{{
                        (contract.name || 'Unnamed').toUpperCase()
                      }}</b>
                    </a>
                    <code @click="$copyText(contract.description)" class="black-text">{{
                      contract.description
                    }}</code>
                  </span>
                  <div class="flex column p4" v-if="show['contract' + contractkey]">
                    <div class="container p4 flex around align-center wrap">
                      <b class="fa fa-edit" @click="
                          inputs.newcontract
                            ? $delete(inputs, 'newcontract')
                            : $set(
                                inputs,
                                'newcontractid',
                                contractkey
                              ), $set(
                                inputs,
                                'newcontract',
                                JSON.parse(JSON.stringify(contract))
                              )
                        "></b>
                      <rm class="m4" :name="contractkey" :obj="$store.state.app.advanced.smartcontracts" :fn="{
                          command: 'dispatch',
                          method: 'update',
                          type: 'app',
                        data: { data: $store.state.app },
                      }" />
                      <b @click="
                          $set(
                            show,
                            'contractmodel' + contractkey,
                            !show['contractmodel' + contractkey]
                          )
                        ">Model</b>
                      <state class="container indicate-border" v-if="show['contractmodel' + contractkey]" nesting="0"
                        editable="true" :statedata="contract" />
                      <a @click="
                          contract.type = 'smartcontract';
                          exportcontract(contract);
                      ">Export</a>
                    </div>
                    
                    <!-- Contract Details -->
                    <div class="container p4">
                      <div class="flex column">
                        <div class="p4">
                          <b>Version:</b> {{ contract.version || '0.1.0' }}
                        </div>
                        <div class="p4" v-if="contract.abi">
                          <b>ABI:</b>
                          <pre class="xs-font" style="max-height: 300px; overflow: scroll; background: rgba(0,0,0,0.1); padding: 8px;">{{ JSON.stringify(contract.abi, null, 2) }}</pre>
                        </div>
                        <div class="p4" v-if="contract.deployments && Object.keys(contract.deployments).length > 0">
                          <b>Deployments:</b>
                          <div v-for="(deployment, network) in contract.deployments" :key="network" class="p4 border-bottom">
                            <div><b>Network:</b> {{ network }}</div>
                            <div><b>Address:</b> {{ deployment.address }}</div>
                            <div><b>Transaction:</b> <a :href="getExplorerUrl(network, deployment.txHash)" target="_blank">{{ deployment.txHash }}</a></div>
                            <div><b>Deployed:</b> {{ new Date(deployment.timestamp).toLocaleString() }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Create and edit contract configurator -->
            <div newcontract v-if="inputs.newcontract" class="p4 flexy sub-container" style="align-self: flex-start">
              <div class="container p8">
                <span class="flex between align-center b8">
                  <span>
                    <b class="update-text md-font r4">{{
                      (
                        inputs["newcontract"].name || "New contract "
                      ).toUpperCase()
                    }}</b>
                    <i>config</i>
                  </span>
                  <button class="update m4 p8 sm-font flex align-center flex-end" text="Save" :disabled="!(
                        inputs.newcontract &&
                        inputs.newcontract.name
                      )
                    " type="button" @click="saveContract()">
                    <div><i class="fa fa-save" /> Save</div>
                  </button>
                </span>
                <div class="flex between container p8 b8">
                  <label class="flex column align-start">
                    <b class="xs-font">Contract Name</b>
                    <input placeholder="Contract name" type="text" v-model="inputs.newcontract.name" />
                  </label>
                  <label class="flex column align-start">
                    <b class="xs-font">Description</b>
                    <input type="text" v-model="inputs.newcontract.description" placeholder="Contract description" />
                  </label>
                  <label class="flex column align-start">
                    <b class="xs-font">Version</b>
                    <input type="text" v-model="inputs.newcontract.version" placeholder="0.1.0" />
                  </label>
                </div>

                <div class="flex wrap column fill" v-if="inputs.newcontract">
                  <!-- Contract Structure Builder - following contractTerms structure -->
                  <div class="flex column b16">
                    <div class="flex align-center between">
                      <b>Contract Structure</b>
                    </div>
                    <div class="xs-font update-border container">
                      <!-- Version -->
                      <div class="container p4 border-bottom">
                        <b>Version:</b> 
                        <input type="text" v-model="inputs.newcontract.version" placeholder="0.1.0" class="xs-input m4" />
                      </div>
                      
                      <!-- Name -->
                      <div class="container p4 border-bottom">
                        <b>Name:</b> 
                        <input type="text" v-model="inputs.newcontract.name" placeholder="Contract name" class="xs-input m4" />
                      </div>
                      
                      <!-- Variables -->
                      <div class="container p4 border-bottom">
                        <div class="flex between align-center">
                          <b>Variables</b>
                          <button class="xs-font indicate p4" @click="$set(show, 'newvariable', true)">
                            <i class="fa fa-plus" /> Add Variable
                          </button>
                        </div>
                        <div v-if="show.newvariable" class="p4">
                          <input v-model="newInput.variableName" placeholder="Variable name" class="xs-input m4" />
                          <input v-model="newInput.variableType" placeholder="Type (uint256, string, etc)" class="xs-input m4" />
                          <input v-model="newInput.variableVisibility" placeholder="Visibility (public, private, etc)" class="xs-input m4" />
                          <button class="xs-font success p4" @click="addVariable()">Add</button>
                          <button class="xs-font warn p4" @click="$set(show, 'newvariable', false)">Cancel</button>
                        </div>
                        <div v-for="(variable, varkey) in (inputs.newcontract.variables || [])" :key="varkey" class="p4">
                          {{ variable.visibility || 'public' }} {{ variable.type }} {{ variable.name }}
                          <rm :name="varkey" :obj="inputs.newcontract.variables" />
                        </div>
                      </div>

                      <!-- Events -->
                      <div class="container p4 border-bottom">
                        <div class="flex between align-center">
                          <b>Events</b>
                          <button class="xs-font indicate p4" @click="$set(show, 'newevent', true)">
                            <i class="fa fa-plus" /> Add Event
                          </button>
                        </div>
                        <div v-if="show.newevent" class="p4">
                          <input v-model="newInput.eventName" placeholder="Event name" class="xs-input m4" />
                          <textarea v-model="newInput.eventParams" placeholder="Parameters (e.g., address indexed from, uint256 amount)" class="xs-input m4"></textarea>
                          <button class="xs-font success p4" @click="addEvent()">Add</button>
                          <button class="xs-font warn p4" @click="$set(show, 'newevent', false)">Cancel</button>
                        </div>
                        <div v-for="(event, eventkey) in (inputs.newcontract.events || [])" :key="eventkey" class="p4">
                          event {{ event.name }}({{ event.params }})
                          <rm :name="eventkey" :obj="inputs.newcontract.events" />
                        </div>
                      </div>

                      <!-- Structs -->
                      <div class="container p4 border-bottom">
                        <div class="flex between align-center">
                          <b>Structs</b>
                          <button class="xs-font indicate p4" @click="$set(show, 'newstruct', true)">
                            <i class="fa fa-plus" /> Add Struct
                          </button>
                        </div>
                        <div v-if="show.newstruct" class="p4">
                          <input v-model="newInput.structName" placeholder="Struct name" class="xs-input m4" />
                          <textarea v-model="newInput.structFields" placeholder="Fields (e.g., uint256 id, string name)" class="xs-input m4"></textarea>
                          <button class="xs-font success p4" @click="addStruct()">Add</button>
                          <button class="xs-font warn p4" @click="$set(show, 'newstruct', false)">Cancel</button>
                        </div>
                        <div v-for="(struct, structkey) in (inputs.newcontract.structs || [])" :key="structkey" class="p4">
                          struct {{ struct.name }} { {{ struct.fields }} }
                          <rm :name="structkey" :obj="inputs.newcontract.structs" />
                        </div>
                      </div>

                      <!-- Mappings -->
                      <div class="container p4 border-bottom">
                        <div class="flex between align-center">
                          <b>Mappings</b>
                          <button class="xs-font indicate p4" @click="$set(show, 'newmapping', true)">
                            <i class="fa fa-plus" /> Add Mapping
                          </button>
                        </div>
                        <div v-if="show.newmapping" class="p4">
                          <input v-model="newInput.mappingName" placeholder="Mapping name" class="xs-input m4" />
                          <input v-model="newInput.mappingKey" placeholder="Key type (e.g., address)" class="xs-input m4" />
                          <input v-model="newInput.mappingValue" placeholder="Value type (e.g., uint256)" class="xs-input m4" />
                          <button class="xs-font success p4" @click="addMapping()">Add</button>
                          <button class="xs-font warn p4" @click="$set(show, 'newmapping', false)">Cancel</button>
                        </div>
                        <div v-for="(mapping, mapkey) in (inputs.newcontract.mappings || [])" :key="mapkey" class="p4">
                          mapping({{ mapping.key }} => {{ mapping.value }}) {{ mapping.name }}
                          <rm :name="mapkey" :obj="inputs.newcontract.mappings" />
                        </div>
                      </div>

                      <!-- Modifiers -->
                      <div class="container p4 border-bottom">
                        <div class="flex between align-center">
                          <b>Modifiers</b>
                          <button class="xs-font indicate p4" @click="$set(show, 'newmodifier', true)">
                            <i class="fa fa-plus" /> Add Modifier
                          </button>
                        </div>
                        <div v-if="show.newmodifier" class="p4">
                          <input v-model="newInput.modifierName" placeholder="Modifier name" class="xs-input m4" />
                          <textarea v-model="newInput.modifierBody" placeholder="Modifier body" class="xs-input m4"></textarea>
                          <button class="xs-font success p4" @click="addModifier()">Add</button>
                          <button class="xs-font warn p4" @click="$set(show, 'newmodifier', false)">Cancel</button>
                        </div>
                        <div v-for="(modifier, modkey) in (inputs.newcontract.modifiers || [])" :key="modkey" class="p4">
                          modifier {{ modifier.name }} { {{ modifier.body }} }
                          <rm :name="modkey" :obj="inputs.newcontract.modifiers" />
                        </div>
                      </div>

                      <!-- Constructor -->
                      <div class="container p4 border-bottom">
                        <b>Constructor</b>
                        <textarea v-model="inputs.newcontract.constructor" placeholder="constructor() { ... }" class="xs-input m4" style="min-height: 100px;"></textarea>
                      </div>

                      <!-- Functions -->
                      <div class="container p4 border-bottom">
                        <div class="flex between align-center">
                          <b>Functions</b>
                          <button class="xs-font indicate p4" @click="$set(show, 'newfunction', true)">
                            <i class="fa fa-plus" /> Add Function
                          </button>
                        </div>
                        <div v-if="show.newfunction" class="p4">
                          <input v-model="newInput.functionName" placeholder="Function name" class="xs-input m4" />
                          <input v-model="newInput.functionVisibility" placeholder="Visibility (public, external, etc)" class="xs-input m4" />
                          <input v-model="newInput.functionModifiers" placeholder="Modifiers (e.g., payable, view)" class="xs-input m4" />
                          <textarea v-model="newInput.functionParams" placeholder="Parameters" class="xs-input m4"></textarea>
                          <input v-model="newInput.functionReturns" placeholder="Returns (e.g., uint256)" class="xs-input m4" />
                          <textarea v-model="newInput.functionBody" placeholder="Function body" class="xs-input m4"></textarea>
                          <button class="xs-font success p4" @click="addFunction()">Add</button>
                          <button class="xs-font warn p4" @click="$set(show, 'newfunction', false)">Cancel</button>
                        </div>
                        <div v-for="(func, funckey) in (inputs.newcontract.functions || [])" :key="funckey" class="p4">
                          {{ func.visibility || 'public' }} {{ func.modifiers || '' }} function {{ func.name }}({{ func.params }}) {{ func.returns ? 'returns (' + func.returns + ')' : '' }} { {{ func.body }} }
                          <rm :name="funckey" :obj="inputs.newcontract.functions" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Deployment Section -->
                  <div class="flex column b16">
                    <div class="flex align-center between">
                      <b>Deployment</b>
                    </div>
                    <div class="xs-font update-border container p4">
                      <div class="flex column">
                        <label class="flex column align-start p4">
                          <b>Network</b>
                          <select v-model="deployment.network" class="xs-input">
                            <option value="">Select Network</option>
                            <option value="ethereum">Ethereum Mainnet</option>
                            <option value="sepolia">Sepolia Testnet</option>
                            <option value="polygon">Polygon</option>
                            <option value="mumbai">Mumbai Testnet</option>
                            <option value="bsc">BSC</option>
                            <option value="bsc-testnet">BSC Testnet</option>
                            <option value="local">Local Network</option>
                          </select>
                        </label>
                        <div v-if="deployment.network" class="p4">
                          <button class="update p4" @click="deployContract()" :disabled="!deployment.network || deploying">
                            {{ deploying ? 'Deploying...' : 'Deploy Contract' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ABI Display -->
                  <div class="flex column b16" v-if="inputs.newcontract.abi && inputs.newcontract.abi.length > 0">
                    <div class="flex align-center between">
                      <b>ABI</b>
                      <button class="xs-font p4" @click="$copyText(JSON.stringify(inputs.newcontract.abi, null, 2))">
                        <i class="fa fa-copy" /> Copy ABI
                      </button>
                    </div>
                    <pre class="xs-font container p4" style="max-height: 400px; overflow: scroll; background: rgba(0,0,0,0.1);">{{ JSON.stringify(inputs.newcontract.abi, null, 2) }}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    contracts() {
      return this.$store.state.app.advanced.smartcontracts || {};
    },
  },
  data() {
    return {
      inputs: {},
      show: {},
      newInput: {},
      deployment: {
        network: '',
      },
      deploying: false,
      models: {
        contract: {
          name: "",
          description: "",
          version: "0.1.0",
          variables: [],
          events: [],
          functions: [],
          structs: [],
          mappings: [],
          modifiers: [],
          constructor: "",
          abi: [],
          deployments: {},
        },
      },
    };
  },
  methods: {
    addVariable() {
      if (!this.inputs.newcontract.variables) {
        this.$set(this.inputs.newcontract, 'variables', []);
      }
      this.inputs.newcontract.variables.push({
        name: this.newInput.variableName,
        type: this.newInput.variableType,
        visibility: this.newInput.variableVisibility || 'public',
      });
      this.newInput.variableName = '';
      this.newInput.variableType = '';
      this.newInput.variableVisibility = '';
      this.$set(this.show, 'newvariable', false);
      this.generateABI();
    },
    addEvent() {
      if (!this.inputs.newcontract.events) {
        this.$set(this.inputs.newcontract, 'events', []);
      }
      this.inputs.newcontract.events.push({
        name: this.newInput.eventName,
        params: this.newInput.eventParams,
      });
      this.newInput.eventName = '';
      this.newInput.eventParams = '';
      this.$set(this.show, 'newevent', false);
      this.generateABI();
    },
    addStruct() {
      if (!this.inputs.newcontract.structs) {
        this.$set(this.inputs.newcontract, 'structs', []);
      }
      this.inputs.newcontract.structs.push({
        name: this.newInput.structName,
        fields: this.newInput.structFields,
      });
      this.newInput.structName = '';
      this.newInput.structFields = '';
      this.$set(this.show, 'newstruct', false);
    },
    addMapping() {
      if (!this.inputs.newcontract.mappings) {
        this.$set(this.inputs.newcontract, 'mappings', []);
      }
      this.inputs.newcontract.mappings.push({
        name: this.newInput.mappingName,
        key: this.newInput.mappingKey,
        value: this.newInput.mappingValue,
      });
      this.newInput.mappingName = '';
      this.newInput.mappingKey = '';
      this.newInput.mappingValue = '';
      this.$set(this.show, 'newmapping', false);
    },
    addModifier() {
      if (!this.inputs.newcontract.modifiers) {
        this.$set(this.inputs.newcontract, 'modifiers', []);
      }
      this.inputs.newcontract.modifiers.push({
        name: this.newInput.modifierName,
        body: this.newInput.modifierBody,
      });
      this.newInput.modifierName = '';
      this.newInput.modifierBody = '';
      this.$set(this.show, 'newmodifier', false);
    },
    addFunction() {
      if (!this.inputs.newcontract.functions) {
        this.$set(this.inputs.newcontract, 'functions', []);
      }
      this.inputs.newcontract.functions.push({
        name: this.newInput.functionName,
        visibility: this.newInput.functionVisibility || 'public',
        modifiers: this.newInput.functionModifiers || '',
        params: this.newInput.functionParams || '',
        returns: this.newInput.functionReturns || '',
        body: this.newInput.functionBody || '',
      });
      this.newInput.functionName = '';
      this.newInput.functionVisibility = '';
      this.newInput.functionModifiers = '';
      this.newInput.functionParams = '';
      this.newInput.functionReturns = '';
      this.newInput.functionBody = '';
      this.$set(this.show, 'newfunction', false);
      this.generateABI();
    },
    generateABI() {
      // Generate ABI from contract structure
      const abi = [];
      
      // Add constructor
      if (this.inputs.newcontract.constructor) {
        abi.push({
          type: 'constructor',
          inputs: [],
          stateMutability: 'nonpayable'
        });
      }
      
      // Add functions
      if (this.inputs.newcontract.functions) {
        this.inputs.newcontract.functions.forEach(func => {
          abi.push({
            type: 'function',
            name: func.name,
            inputs: this.parseParams(func.params),
            outputs: func.returns ? this.parseParams(func.returns) : [],
            stateMutability: func.modifiers.includes('payable') ? 'payable' : 
                           func.modifiers.includes('view') ? 'view' : 
                           func.modifiers.includes('pure') ? 'pure' : 'nonpayable'
          });
        });
      }
      
      // Add events
      if (this.inputs.newcontract.events) {
        this.inputs.newcontract.events.forEach(event => {
          abi.push({
            type: 'event',
            name: event.name,
            inputs: this.parseParams(event.params, true),
            anonymous: false
          });
        });
      }
      
      this.$set(this.inputs.newcontract, 'abi', abi);
    },
    parseParams(paramsString, isEvent = false) {
      if (!paramsString || !paramsString.trim()) return [];
      
      const params = [];
      const parts = paramsString.split(',').map(p => p.trim());
      
      parts.forEach(part => {
        if (!part) return;
        const indexed = isEvent && part.includes('indexed');
        const cleanPart = part.replace('indexed', '').trim();
        const words = cleanPart.split(/\s+/);
        if (words.length >= 2) {
          params.push({
            name: words[words.length - 1],
            type: words.slice(0, -1).join(' '),
            indexed: indexed
          });
        }
      });
      
      return params;
    },
    async saveContract() {
      if (!this.inputs.newcontract.name) return;
      
      if (!this.$store.state.app.advanced.smartcontracts) {
        this.$set(this.$store.state.app, 'advanced', {
          ...this.$store.state.app.advanced,
          smartcontracts: {}
        });
      }
      
      const hash = await this.$store.dispatch('util', {
        type: 'hash',
        body: this.inputs.newcontract,
      });
      
      this.$set(
        this.$store.state.app.advanced.smartcontracts,
        hash,
        this.inputs.newcontract
      );
      
      if (this.inputs.newcontractid && this.inputs.newcontractid !== hash) {
        this.$delete(this.$store.state.app.advanced.smartcontracts, this.inputs.newcontractid);
      }
      
      this.$set(this.inputs, 'newcontractid', hash);
      this.$set(this.show, 'contract' + hash, true);
      
      await this.$store.dispatch('update', {
        type: 'app',
        data: this.$store.state.app,
      });
    },
    async deployContract() {
      if (!this.deployment.network || !this.inputs.newcontract) return;
      
      this.deploying = true;
      
      try {
        // This would call a deployment service/function
        // For now, we'll simulate deployment
        const deploymentData = {
          address: '0x' + Math.random().toString(16).substr(2, 40),
          txHash: '0x' + Math.random().toString(16).substr(2, 64),
          timestamp: Date.now(),
        };
        
        if (!this.inputs.newcontract.deployments) {
          this.$set(this.inputs.newcontract, 'deployments', {});
        }
        
        this.$set(
          this.inputs.newcontract.deployments,
          this.deployment.network,
          deploymentData
        );
        
        await this.saveContract();
        
        alert(`Contract deployed to ${this.deployment.network} at ${deploymentData.address}`);
      } catch (error) {
        console.error('Deployment error:', error);
        alert('Deployment failed: ' + error.message);
      } finally {
        this.deploying = false;
      }
    },
    getExplorerUrl(network, txHash) {
      const explorers = {
        ethereum: `https://etherscan.io/tx/${txHash}`,
        sepolia: `https://sepolia.etherscan.io/tx/${txHash}`,
        polygon: `https://polygonscan.com/tx/${txHash}`,
        mumbai: `https://mumbai.polygonscan.com/tx/${txHash}`,
        bsc: `https://bscscan.com/tx/${txHash}`,
        'bsc-testnet': `https://testnet.bscscan.com/tx/${txHash}`,
      };
      return explorers[network] || '#';
    },
    exportcontract(contract) {
      this.$store.dispatch("export", contract);
    },
  },
  watch: {
    'inputs.newcontract': {
      handler() {
        if (this.inputs.newcontract) {
          this.generateABI();
        }
      },
      deep: true
    }
  }
};
</script>
<style scoped>
</style>
